function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
var Connected = function Connected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size || 16,
    height: props.size || 16,
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: props.size > 16 ? 0 : 0.8,
    stroke: props.size <= 16 ? props.color ? props.color : "#242328" : "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || "#242328",
    fillRule: "evenodd",
    d: "M15.74 4.5a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0M17.99.75a3.75 3.75 0 0 0-2.535 6.514l-.719 1.198a3.7 3.7 0 0 0-1.246-.212c-.96 0-1.835.36-2.498.953L9.547 7.812a3 3 0 1 0-.878 1.237l1.42 1.367A3.7 3.7 0 0 0 9.74 12c0 .466.085.912.24 1.324l-2.718 1.71a3 3 0 1 0 .82 1.256l2.699-1.697a3.74 3.74 0 0 0 2.709 1.157c.403 0 .791-.064 1.155-.181l1.162 2.045a3 3 0 1 0 1.519-.363L15.95 14.83c.79-.688 1.289-1.7 1.289-2.83a3.74 3.74 0 0 0-1.218-2.766l.718-1.197A3.75 3.75 0 1 0 17.99.75M8.016 7.539l-.032.05A1.499 1.499 0 0 1 5.24 6.75a1.5 1.5 0 1 1 2.776.789M13.49 9.75c.398 0 .772.103 1.096.284a1 1 0 0 0 .12.072 2.25 2.25 0 1 1-1.215-.356m3.75 9a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3m-13.5-1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
    clipRule: "evenodd"
  }));
};
export default Connected;
Connected.displayName = 'Connected';